<template>
    <USelectMenu
        size="lg"
        :model-value="filter.selected"
        @update:model-value="onUpdate($event)"
        :options="[
            { name: 'Open', value: InvoiceStatus.open, dot: 'bg-blue-500' },
            { name: 'Settled', value: InvoiceStatus.settled, dot: 'bg-emerald-500' },
            { name: 'Voided', value: InvoiceStatus.voided, dot: 'bg-red-500' },
        ]"
    >
        <template #label>
            <template v-if="filter.selected">
                <span :class="[filter.selected.dot, 'inline-block size-1.5 flex-shrink-0 rounded-full']" aria-hidden="true" />
                <span class="truncate font-medium">{{ filter.selected.name }}</span>
            </template>
            <span v-else class="text-gray-400">Select...</span>
        </template>
        <template #option="{ option }">
            <span :class="[option.dot, 'inline-block size-1.5 mx-1 flex-shrink-0 rounded-full']" aria-hidden="true" />
            <span class="truncate">{{ option.name }}</span>
        </template>
    </USelectMenu>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'
import { InvoiceStatus } from '~/types/invoice'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

function onUpdate(event: any) {
    emit('update:filter', {
        ...props.filter,
        selected: event,
        value: event.value,
    })
}
</script>